/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientInfo } from './ClientInfo';
import {
    ClientInfoFromJSON,
    ClientInfoFromJSONTyped,
    ClientInfoToJSON,
} from './ClientInfo';
import type { MoneyModel } from './MoneyModel';
import {
    MoneyModelFromJSON,
    MoneyModelFromJSONTyped,
    MoneyModelToJSON,
} from './MoneyModel';
import type { BrokerInfo } from './BrokerInfo';
import {
    BrokerInfoFromJSON,
    BrokerInfoFromJSONTyped,
    BrokerInfoToJSON,
} from './BrokerInfo';

/**
 * 
 * @export
 * @interface ClaimResponse
 */
export interface ClaimResponse {
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    lossLocation: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    presentPosition: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    presentPositionNote: string | null;
    /**
     * 
     * @type {any}
     * @memberof ClaimResponse
     */
    presentPositionId: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    presentPositionName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    dateOfLoss: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    policyNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    customerRef: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    instructedDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    firstContactDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    siteVisitDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimResponse
     */
    firstReportDate: Date;
    /**
     * 
     * @type {MoneyModel}
     * @memberof ClaimResponse
     */
    totalReserve: MoneyModel | null;
    /**
     * 
     * @type {MoneyModel}
     * @memberof ClaimResponse
     */
    outstanding: MoneyModel | null;
    /**
     * 
     * @type {ClientInfo}
     * @memberof ClaimResponse
     */
    primaryClient: ClientInfo | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    insuredContact: string | null;
    /**
     * 
     * @type {BrokerInfo}
     * @memberof ClaimResponse
     */
    broker: BrokerInfo | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimResponse
     */
    currency: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimResponse
     */
    caseId: number;
}

/**
 * Check if a given object implements the ClaimResponse interface.
 */
export function instanceOfClaimResponse(value: object): value is ClaimResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('lossLocation' in value) || value['lossLocation'] === undefined) return false;
    if (!('presentPosition' in value) || value['presentPosition'] === undefined) return false;
    if (!('presentPositionNote' in value) || value['presentPositionNote'] === undefined) return false;
    if (!('presentPositionId' in value) || value['presentPositionId'] === undefined) return false;
    if (!('presentPositionName' in value) || value['presentPositionName'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    if (!('policyNumber' in value) || value['policyNumber'] === undefined) return false;
    if (!('customerRef' in value) || value['customerRef'] === undefined) return false;
    if (!('instructedDate' in value) || value['instructedDate'] === undefined) return false;
    if (!('firstContactDate' in value) || value['firstContactDate'] === undefined) return false;
    if (!('siteVisitDate' in value) || value['siteVisitDate'] === undefined) return false;
    if (!('firstReportDate' in value) || value['firstReportDate'] === undefined) return false;
    if (!('totalReserve' in value) || value['totalReserve'] === undefined) return false;
    if (!('outstanding' in value) || value['outstanding'] === undefined) return false;
    if (!('primaryClient' in value) || value['primaryClient'] === undefined) return false;
    if (!('insuredContact' in value) || value['insuredContact'] === undefined) return false;
    if (!('broker' in value) || value['broker'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('caseId' in value) || value['caseId'] === undefined) return false;
    return true;
}

export function ClaimResponseFromJSON(json: any): ClaimResponse {
    return ClaimResponseFromJSONTyped(json, false);
}

export function ClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'lossLocation': json['lossLocation'],
        'presentPosition': json['presentPosition'],
        'presentPositionNote': json['presentPositionNote'],
        'presentPositionId': json['presentPositionId'],
        'presentPositionName': json['presentPositionName'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
        'policyNumber': json['policyNumber'],
        'customerRef': json['customerRef'],
        'instructedDate': (new Date(json['instructedDate'])),
        'firstContactDate': (new Date(json['firstContactDate'])),
        'siteVisitDate': (new Date(json['siteVisitDate'])),
        'firstReportDate': (new Date(json['firstReportDate'])),
        'totalReserve': MoneyModelFromJSON(json['totalReserve']),
        'outstanding': MoneyModelFromJSON(json['outstanding']),
        'primaryClient': ClientInfoFromJSON(json['primaryClient']),
        'insuredContact': json['insuredContact'],
        'broker': BrokerInfoFromJSON(json['broker']),
        'currency': json['currency'],
        'caseId': json['caseId'],
    };
}

export function ClaimResponseToJSON(value?: ClaimResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'lossLocation': value['lossLocation'],
        'presentPosition': value['presentPosition'],
        'presentPositionNote': value['presentPositionNote'],
        'presentPositionId': value['presentPositionId'],
        'presentPositionName': value['presentPositionName'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString().substring(0,10)),
        'policyNumber': value['policyNumber'],
        'customerRef': value['customerRef'],
        'instructedDate': ((value['instructedDate']).toISOString().substring(0,10)),
        'firstContactDate': ((value['firstContactDate']).toISOString().substring(0,10)),
        'siteVisitDate': ((value['siteVisitDate']).toISOString().substring(0,10)),
        'firstReportDate': ((value['firstReportDate']).toISOString().substring(0,10)),
        'totalReserve': MoneyModelToJSON(value['totalReserve']),
        'outstanding': MoneyModelToJSON(value['outstanding']),
        'primaryClient': ClientInfoToJSON(value['primaryClient']),
        'insuredContact': value['insuredContact'],
        'broker': BrokerInfoToJSON(value['broker']),
        'currency': value['currency'],
        'caseId': value['caseId'],
    };
}

